module.exports = __webpack_public_path__ + "img/logboek.fc33e434.png";